// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { hasCookieConsent } from "./hooks/useCookieConsent";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBx6Ci6LCangdbl9gwydpbZmrVQKT4yp3Y",
  authDomain: "quotabus-landing-pages.firebaseapp.com",
  projectId: "quotabus-landing-pages",
  storageBucket: "quotabus-landing-pages.firebasestorage.app",
  messagingSenderId: "971555561460",
  appId: "1:971555561460:web:e55f74281227572ef8a3a1",
  measurementId: "G-WF5C8J7R8Z",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export let analytics = null;

function ensureAnalyticsEnabled() {
  if (analytics) return analytics;
  if (!hasCookieConsent("analytics")) return null;
  analytics = getAnalytics(app);
  return analytics;
}

export const FirebaseAnalytics = () => {
  const location = useLocation();
  const { i18n } = useTranslation();

  const logPageView = (a) => {
    const page_path = location.pathname + location.search;
    const busPartnerCode = process.env.REACT_APP_PARTNER_CODE;
    logEvent(a, "page_view", {
      page_path: "lp-" + busPartnerCode + page_path,
      bus_partner: busPartnerCode,
      user_lang: i18n.language,
    });
  };

  useEffect(() => {
    const a = ensureAnalyticsEnabled();
    if (a) {
      logPageView(a);
    }
  }, [location, i18n.language]);

  useEffect(() => {
    const onConsentUpdate = () => {
      const a = ensureAnalyticsEnabled();
      if (a) logPageView(a);
    };
    window.addEventListener("cookieConsentUpdated", onConsentUpdate);
    return () => window.removeEventListener("cookieConsentUpdated", onConsentUpdate);
  }, []);

  return null;
};
